import React from "react";
import {
    Box,
    TextField,
    Button,
    Typography,
    Stack,
    CircularProgress
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";

interface SearchSectionProps {
    searchTerm: string;
    onSearchTermChange: (value: string) => void;
    onSearch: () => void;
    onKeyPress: (event: React.KeyboardEvent) => void;
    isSearching: boolean;
}

export const SearchSection: React.FC<SearchSectionProps> = ({
    searchTerm,
    onSearchTermChange,
    onSearch,
    onKeyPress,
    isSearching
}) => {
    return (
        <Box>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                Search for User
            </Typography>
            <Stack direction="row" spacing={1}>
                <TextField
                    placeholder="Enter name or email address..."
                    value={searchTerm}
                    onChange={(e) => onSearchTermChange(e.target.value)}
                    onKeyPress={onKeyPress}
                    size="small"
                    fullWidth
                    disabled={isSearching}
                />
                <Button
                    variant="contained"
                    onClick={onSearch}
                    disabled={isSearching || searchTerm.length < 2}
                    startIcon={isSearching ? <CircularProgress size={16} /> : <SearchIcon />}
                    sx={{
                        backgroundColor: '#162346',
                        '&:hover': { backgroundColor: '#1a2a52' },
                        minWidth: 100
                    }}
                >
                    {isSearching ? 'Searching...' : 'Search'}
                </Button>
            </Stack>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                Enter at least 2 characters to search for users in your organization
            </Typography>
        </Box>
    );
};
